import { useCallback, useDebugValue, useMemo } from "react";
import { useAsyncSafeState } from "./useAsyncSafeState";

/**
 *
 * @param startCount - Optional - Defaults to 0 if left empty.
 */
export const useLoadingState = (startCount: number = 0) => {
  const [loadingCount, setLoadingCount] = useAsyncSafeState<number>(startCount);

  const startLoading = useCallback(() => {
    setLoadingCount((prev) => prev + 1);
  }, [setLoadingCount]);

  const stopLoading = useCallback(() => {
    setLoadingCount((prev) => prev - 1);
  }, [setLoadingCount]);

  useDebugValue((loadingCount ?? 0) > 0 ? "Loading" : "Not loading");

  return useMemo(
    () => ({
      isLoading: (loadingCount ?? 0) > 0,
      startLoading,
      stopLoading,
    }),
    [loadingCount, startLoading, stopLoading]
  );
};
